document.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll<HTMLElement>('[data-aos]')
  if (!elements.length) return

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const delay = Number.parseInt(
            (entry.target as HTMLElement).dataset.aosDelay ?? '0',
          )
          setTimeout(() => {
            entry.target.classList.add('aos-animate')
          }, delay)
          observer.unobserve(entry.target)
        }
      }
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' },
  )

  for (const el of elements) {
    observer.observe(el)
  }
})
